module.exports = __webpack_public_path__ + "static/media/Nexa.741bec04.ttf";